import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('billing');

export class MassDelivery extends Api {
  constructor(http, config = {}) {
    super(http, url, 'mass-delivery', config);
  }
}
